import { NgModule } from '@angular/core';
import { V2LHoverComponent } from './v2l-hover.component';
import { SharedProviderModule } from '~app/shared/shared.module';

@NgModule({
  imports: [
    SharedProviderModule
  ],
  declarations: [V2LHoverComponent],
  exports: [V2LHoverComponent]
})
export class V2LInfoModule {
}
